export function useFormatPrice(value) {
            let val = (value/1).toFixed(2);
            let formattedVal = "$" + val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            return formattedVal.replace("$-", "-$");
}